//------------------------------ Responsive left column------------------
function responsivecolumn()
{
	if ($(document).width() <= 991)
	{
		$('.main-content .contents.page-width .side-bar').appendTo('.main-content .contents.page-width');
	}
	else if($(document).width() >= 992)
	{
		$('.main-content .contents.page-width .side-bar').prependTo('.main-content .contents.page-width');
	}
}
$(document).ready(function(){responsivecolumn(); });
$(window).resize(function(){responsivecolumn(); });

//==================== category toggle ====================//
$(document).ready(function(){
	$(".header-center .categories_title").click(function(){
	$(".header-center #CategoryBox #SiteCat").slideToggle(800);
	$('.header-center .categories_title').toggleClass('active'); 
	});
});

//====================collection-list slider======================//
var topsliders = document.getElementById('collection-item-tm');
var topowl1 = $("#collection-item-tm");
$(topowl1).each(function (index) {
  topowl1.owlCarousel({
    items : 7, //10 items above 1000px browser width
    itemsDesktop : [1269,5], //5 items between 1000px and 901px
    itemsDesktopSmall : [989,4], // betweem 900px and 601px
    itemsTablet: [749,3], //2 items between 600 and 0
    itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
    autoPlay: true
  });
  $("a.next").click(function(){
    topowl1.trigger('owl.next');
  });
  $("a.prev").click(function(){
    topowl1.trigger('owl.prev');
  });
});

//========================brand list slider==========================//
var brandsowl = $("#brands_list_slider");
brandsowl.owlCarousel({
  items : 7, //10 items above 1000px browser width
  itemsDesktop : [1269,6], //4 items between 1269px and 990px
  itemsDesktopSmall : [989,5], //4 items betweem 989px and 750px
  itemsTablet: [749,3], //2 items between 749 and 480
  itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
});
$(".brands_next").click(function(){
  brandsowl.trigger('owl.next');
});
$(".brands_prev").click(function(){
  brandsowl.trigger('owl.prev');
});

//==========================back-to-top=======================//
$(window).scroll(function() {
if ($(this).scrollTop() > 500) {
$('.top_button').fadeIn(500);
} else {
$('.top_button').fadeOut(500);
}
});	
$('.top_button').click(function(event) {
event.preventDefault();	
$('html, body').animate({scrollTop: 0}, 800);
});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product_tab-block ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  $(".tm_headerlinkmenu").doubleTapToGo()
  });

//=================== thumnails slider ===================//
$(document).ready(function() {
    var addslider = $("#addition-slider");
  	  if ($(window).width() > 749){
        addslider.owlCarousel({
            items : 4 , //10 items above 1000px browser width
            itemsDesktop : [1280,4], //5 items between 1000px and 901px
            itemsDesktopSmall : [990,3], // betweem 900px and 601px
            itemsTablet: [749,4], //2 items between 600 and 0
            itemsMobile : [479,2] // itemsMobile disabled - inherit from itemsTablet option
        });
        $(".add_next").click(function(){
            addslider.trigger('owl.next'); 
        });
        $(".add_prev").click(function(){
            addslider.trigger('owl.prev');
        });
      }
});  

//======================== Sticky header ======================//
function StickyHeader(){	
	"use strict";	
	var num = 145; //number of pixels before modifying styles
	
		jQuery(window).bind('scroll', function () {
			if (jQuery(window).scrollTop() > num) {
				jQuery('.header-fix').addClass('sticky-menu');
				jQuery('.site-header-fix').addClass('header-style');
				jQuery('.category-box').addClass('home-category-fix');
				jQuery('.home-category').addClass('home-category-fix1');
				
			} else {
				jQuery('.header-fix').removeClass('sticky-menu');		
				jQuery('.site-header-fix').removeClass('header-style');
				jQuery('.category-box').removeClass('home-category-fix');
			}
		})
}
jQuery(document).ready(function() { "use strict";   StickyHeader()});
jQuery(window).resize(function() {  "use strict";   StickyHeader()});

//====================== collection tab =======================//
$(document).ready(function() {
    $('.product-single__description ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });

/*==================sidebar toggle====================*/
function mobileToggleColumn1(){
  if ($(window).width() < 990){
    $(".side-bar h3.box-heading, .side-bar .categories_title").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar h3.box-heading, .side-bar .categories_title").addClass('toggle');
    $(".side-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.box-content').slideToggle('slow');
    });    
  }
  else{
    $(".side-bar h3.box-heading, .side-bar .categories_title").removeClass('toggle');
    $(".side-bar h3.box-heading, .side-bar .categories_title").removeClass('active');
    $(".side-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn1);

/*==================footer toggle====================*/
function mobileToggleColumn(){
  if ($(window).width() < 990){
    $(".site-footer .footer-box  h5").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".site-footer .footer-box h5").addClass('toggle');
    $(".footer-box .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').parent().find('.footer-content').slideToggle('slow');
    });    
  }
  else{
    $(".site-footer .footer-box  h5").removeClass('toggle');
    $(".site-footer .footer-box h5").removeClass('active');
    $(".footer-box .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleColumn);

/*================== category-box ===================*/
function mobileToggleMenu2(){
  if ($(window).width() < 990){
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');
       
    });    
  }
  else
  {
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").removeClass('toggle')
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").removeClass('active');
    $("#CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleMenu2);

function mobileToggleMenu3(){
  if ($(window).width() < 990){
    $(" #CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(" #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").addClass('toggle');
    $(" #CategoryBox  ul#SiteCat li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find(' .grand-child-has-dropdown').slideToggle('slow');
       
    });    
  }
  else
  {
    $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").removeClass('toggle')
    $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown").removeClass('active');
    $("#CategoryBox  ul#SiteCat  li.site-cat--has-dropdown .site-nav__childlist-item-dropdown .mobile_togglemenu").remove();
  }
}
$(document).ready(mobileToggleMenu3);

/*================== sidebar category-box ===================*/
function mobileToggleMenu4(){
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").append( "<span class='mobile_togglemenu'> </span>" );  
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown").addClass('toggle');
    $(".side-bar #CategoryBox  ul#SiteCat > li.site-cat--has-dropdown .mobile_togglemenu").click(function(){
       $(this).parent().toggleClass('active').find('.site-nav__dropdown').slideToggle('slow');    
    });    
}
$(document).ready(mobileToggleMenu4);

//======================new-text collection slider======================//
// var topsliders = document.getElementById('new-text_products_slider');
// var topowl3 = $("#new-text_products_slider");
// $(topowl3).each(function (index) {
//   $(this).owlCarousel({
//     items : 5, //10 items above 1000px browser width
//     itemsDesktop : [1269,4], //5 items between 1000px and 901px
//     itemsDesktopSmall : [989,3], // betweem 900px and 601px
//     itemsTablet: [749,3], //2 items between 600 and 0
//     itemsMobile : [479,2], // itemsMobile disabled - inherit from itemsTablet option
//   });

//   $(".new-text_next").click(function(){
//     $(topowl3).trigger('owl.next');
//   });
//   $(".new-text_prev").click(function(){
//     $(topowl3).trigger('owl.prev');
//   });
// });
